module.exports = __webpack_public_path__ + "img/F@2x.559372b4.jpg";